module.exports = __webpack_public_path__ + "img/gallery-blue.10abec21.png";